import { VariableType } from "../VariableType";
import { BaseTypeSchema } from "../BaseTypeSchema";

export class StringSchema extends BaseTypeSchema
{
    min_length: number | null;
    max_length: number | null;
    regex?: RegExp;
    constructor(required: boolean, min_length: number | null = null, max_length: number | null = null)
    {
        super(VariableType.String, required);
        this.min_length = min_length;
        this.max_length = max_length;
    }
    setMinLength(min_length: number | null): StringSchema
    {
        this.min_length = min_length;
        return this;
    }
    setMaxLength(max_length: number | null): StringSchema
    {
        this.max_length = max_length;
        return this;
    }
    setRegex(regex?: RegExp): StringSchema
    {
        this.regex = regex;
        return this;
    }
}